module.exports = __webpack_public_path__ + "static/adobe-ps-8ca8f89d1be259c6426e2b49efa0754a.svg";